(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lucevia-product-benefits"] && !Shopify.designMode) return;
  try {
    function initializeLuceviaBenefits() {
    document
      .querySelectorAll('.lucevia-benefits')
      .forEach((container) => {
        if (container.dataset.initialized === 'true') return;

        container.dataset.initialized = 'true';

        const button = container.querySelector(
          '.lucevia-benefits__info-button'
        );

        const popup = container.querySelector(
          '.lucevia-benefits__popup'
        );

        if (!button || !popup) return;

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const willOpen = popup.hidden;

          popup.hidden = !willOpen;
          button.setAttribute('aria-expanded', String(willOpen));
        });
      });
  }

  initializeLuceviaBenefits();

  document.addEventListener(
    'shopify:section:load',
    initializeLuceviaBenefits
  );

  document.addEventListener('click', (event) => {
    document
      .querySelectorAll('.lucevia-benefits')
      .forEach((container) => {
        if (container.contains(event.target)) return;

        const button = container.querySelector(
          '.lucevia-benefits__info-button'
        );

        const popup = container.querySelector(
          '.lucevia-benefits__popup'
        );

        if (popup) popup.hidden = true;

        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll('.lucevia-benefits')
      .forEach((container) => {
        const button = container.querySelector(
          '.lucevia-benefits__info-button'
        );

        const popup = container.querySelector(
          '.lucevia-benefits__popup'
        );

        if (popup) popup.hidden = true;

        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      });
  });
  } catch(e) { console.error(e); }
})();

})();
